import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { User, Mail } from "lucide-react";

export default function Account() {
  const { user, setUser } = useAuth();
  const [form, setForm] = useState({ name: "", phone_number: "", address: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user) {
      setForm({
        name: user.name || "",
        phone_number: user.phone_number || "",
        address: user.address || "",
      });
    }
  }, [user]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.patch("/auth/me", form);
      setUser({
        id: data.id, email: data.email, name: data.name, role: data.role,
        phone_number: data.phone_number, address: data.address,
      });
      toast.success("Profilen din er oppdatert");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  if (!user) return null;
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="tk-container py-16 max-w-2xl" data-testid="account-page">
      <p className="tk-overline mb-3">Konto</p>
      <h1 className="text-3xl sm:text-4xl font-semibold mb-2">Mine opplysninger</h1>
      <p className="text-sm text-slate-500 mb-10">
        Oppdater navn, telefon og leveringsadresse — verkstedet bruker dette ved levering og henting.
      </p>

      <div className="tk-card mb-8 flex items-center gap-4">
        <div className="w-12 h-12 rounded-md bg-[#0B1C30]/5 flex items-center justify-center">
          <User size={22} className="text-[#0B1C30]" />
        </div>
        <div>
          <p className="font-semibold">{user.name}</p>
          <p className="text-sm text-slate-500 flex items-center gap-1.5">
            <Mail size={14} /> {user.email}
          </p>
        </div>
      </div>

      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="text-sm font-medium text-slate-700">Fullt navn</label>
          <input className="tk-input mt-1" required value={form.name} onChange={set("name")} data-testid="account-name-input" />
        </div>
        <div>
          <label className="text-sm font-medium text-slate-700">Telefonnummer</label>
          <input className="tk-input mt-1" placeholder="+47 …" value={form.phone_number} onChange={set("phone_number")} data-testid="account-phone-input" />
        </div>
        <div>
          <label className="text-sm font-medium text-slate-700">Adresse</label>
          <input className="tk-input mt-1" placeholder="Gateadresse, postnr og by" value={form.address} onChange={set("address")} data-testid="account-address-input" />
        </div>
        <button type="submit" disabled={busy} className="tk-btn-primary" data-testid="account-save-btn">
          {busy ? "Lagrer …" : "Lagre endringer"}
        </button>
      </form>
    </div>
  );
}
